// shared/src/commonMain/kotlin/com/tovtalk/data/remote/dto/PostDtoV2.kt
package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/** Wrapper for single-post V2 responses: {"data": {"item": {...}}} */
@Serializable
data class SinglePostWrapper(
    @SerialName("item") val item: PostDtoV2? = null,
    @SerialName("kashrut_restricted") val kashrutRestricted: Boolean = false
)

@Serializable
data class PostDtoV2(
    val id: Int,
    val ref: String,
    val type: String,
    val caption: String? = null,
    val hashtags: List<String>? = null,
    val stats: PostStatsDto,
    val author: AuthorDto? = null,
    val viewer: ViewerDto = ViewerDto(),
    val media: MediaDto,
    @SerialName("created_at") val createdAt: String,
    @SerialName("original_video_time") val originalVideoTime: String? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    @SerialName("is_expired") val isExpired: Boolean = false,
    @SerialName("is_permanent") val isPermanent: Boolean = true,
    @SerialName("is_pinned") val isPinned: Boolean = false,
    @SerialName("uploaded_via_admin") val uploadedViaAdmin: Boolean = false
)

@Serializable
data class PostStatsDto(
    val views: Int = 0,
    val likes: Int = 0,
    val comments: Int = 0,
    val saves: Int = 0,
    val shares: Int = 0
)

@Serializable
data class AuthorDto(
    val id: Int,
    val username: String,
    val fullname: String? = null,
    @SerialName("profile_photo") val profilePhoto: String? = null,
    @SerialName("has_active_story") val hasActiveStory: Boolean = false
)

@Serializable
data class ViewerDto(
    @SerialName("is_liked") val isLiked: Boolean = false,
    @SerialName("is_saved") val isSaved: Boolean = false,
    @SerialName("is_following") val isFollowing: Boolean = false
)

@Serializable
data class MediaDto(
    val sources: Map<String, String> = emptyMap(),
    val duration: Double? = null,
    val thumbnail: String? = null,
    val sizes: Map<String, Int>? = null
)
